/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiserviceMelcoModelsCustomWarning,
    ApiserviceMelcoModelsCustomWarningFromJSON,
    ApiserviceMelcoModelsCustomWarningFromJSONTyped,
    ApiserviceMelcoModelsCustomWarningToJSON,
    ApiserviceMelcoModelsDesignListItem,
    ApiserviceMelcoModelsDesignListItemFromJSON,
    ApiserviceMelcoModelsDesignListItemFromJSONTyped,
    ApiserviceMelcoModelsDesignListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItem
 */
export interface ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItem {
    /**
     * 
     * @type {Array<ApiserviceMelcoModelsDesignListItem>}
     * @memberof ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItem
     */
    list: Array<ApiserviceMelcoModelsDesignListItem>;
    /**
     * 
     * @type {Array<ApiserviceMelcoModelsCustomWarning>}
     * @memberof ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItem
     */
    warning_list?: Array<ApiserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItem
     */
    total: number;
}

export function ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItemFromJSON(json: any): ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItem {
    return ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItemFromJSONTyped(json, false);
}

export function ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ApiserviceMelcoModelsDesignListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ApiserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItemToJSON(value?: ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ApiserviceMelcoModelsDesignListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ApiserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


